import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { inject } from '@angular/core';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const router = inject(Router);
  const requiredRole = route.data['role'];
  const hasRequiredRole = (role: string): boolean => Object.values(grantedRoles.realmRoles).some((roles) => roles.includes(role));

  if (!authenticated) {
    return router.parseUrl('/login');
  }

  if (!requiredRole || hasRequiredRole(requiredRole)) {
    return true;
  }

  return router.parseUrl('/forbidden');
};

export const canActivate = createAuthGuard<CanActivateFn>(isAccessAllowed);
